import { render, staticRenderFns } from "./MenuDevelopment.vue?vue&type=template&id=10d5259e&"
import script from "./MenuDevelopment.vue?vue&type=script&lang=js&"
export * from "./MenuDevelopment.vue?vue&type=script&lang=js&"
import style0 from "./MenuDevelopment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports